BaseModel = require './base_model.coffee'

class global.Tag extends BaseModel
  @ATTRIBUTES =
    id: {}
    name: {}
    color: {}
    taggable_tag_id: {}

  @colors = [
    '27C3E2','3FA8E4','2D7DAA','5DCE49','54BB42','6DB03C','F7DB1F','EFC017',
    'F6AF16','F68F16','FA6252','E4524D','C43C37','EC6296','D83E78','5A0C91'
  ]



// WEBPACK FOOTER //
// ./src/models/tag.coffee